<div class="d-flex gap-3 mb-3" style="max-width: 690px">
  <div class="flex-fill" style="min-width: 220px; align-self: center">
    <chitin-checkbox
      label="Today"
      data-cy="datePickerTodayPreset"
      data-testid="datePickerTodayPreset"
      [value]="selectedPreset()?.id === 'this' && selectedPreset()?.modifier === 'day'"
      (click)="selectPreset({ id: 'this', modifier: 'day' }, $event)"
      mode="radio"
      class="w-fit"
    />
    <chitin-checkbox
      data-cy="datePickerYesterdayPreset"
      data-testid="datePickerYesterdayPreset"
      label="Yesterday"
      [value]="selectedPreset()?.id === 'last' && selectedPreset()?.modifier === 'day'"
      (click)="selectPreset({ id: 'last', modifier: 'day' }, $event)"
      mode="radio"
      class="w-fit"
    />
    @if (!hideThisSelection()) {
      @let thisSelected = selectedPreset()?.id === 'this' && selectedPreset()?.modifier !== 'day';
      <chitin-checkbox
        data-cy="datePickerThisPreset"
        [value]="thisSelected"
        (click)="selectPreset({ id: 'this', modifier: selectedThisModifier() }, $event)"
        mode="radio"
        class="w-fit"
      >
        <div class="d-flex gap-2 align-items-center">
          <div>This</div>
          <chitin-select
            size="sm"
            [options]="daterangeModifierOptions()"
            appendTo="parent"
            [value]="thisSelected ? (selectedPreset()?.modifier ?? selectedThisModifier()) : selectedThisModifier()"
            (valueChange)="selectedThisModifier.set($event ?? selectedThisModifier())"
          />
        </div>
      </chitin-checkbox>
    }
    @let lastSelected = selectedPreset()?.id === 'last' && selectedPreset()?.modifier !== 'day';
    <chitin-checkbox
      data-cy="datePickerLastPreset"
      [value]="lastSelected"
      (click)="selectPreset({ id: 'last', modifier: selectedLastModifier() }, $event)"
      mode="radio"
      class="w-fit"
    >
      <div class="d-flex gap-2 align-items-center">
        <div>Last</div>
        <chitin-select
          size="sm"
          [options]="daterangeModifierOptions()"
          appendTo="parent"
          [value]="lastSelected ? (selectedPreset()?.modifier ?? selectedLastModifier()) : selectedLastModifier()"
          (valueChange)="selectedLastModifier.set($event ?? selectedLastModifier())"
        />
      </div>
    </chitin-checkbox>
    @let toDateSelected = selectedPreset()?.id === 'toDate';
    <chitin-checkbox
      data-cy="datePickerToDatePreset"
      data-testid="datePickerToDatePreset"
      [value]="toDateSelected"
      (click)="selectPreset({ id: 'toDate', modifier: selectedToDateModifier() }, $event)"
      mode="radio"
      class="w-fit"
    >
      <div class="d-flex gap-2 align-items-center">
        <chitin-select
          size="sm"
          [options]="daterangeModifierOptions()"
          appendTo="parent"
          [value]="toDateSelected ? (selectedPreset()?.modifier ?? selectedToDateModifier()) : selectedToDateModifier()"
          (valueChange)="selectedToDateModifier.set($event ?? selectedToDateModifier())"
        />
        <div>To Date</div>
      </div>
    </chitin-checkbox>
    @let customSelected = selectedPreset()?.id === 'custom';
    <chitin-checkbox
      data-cy="datePickerCustomPreset"
      class="mb-0 w-fit"
      label="Custom"
      [value]="customSelected"
      mode="radio"
      (click)="selectPreset({ id: 'custom' }, $event)"
    />
    @if (customSelected) {
      <div class="d-flex align-items-center gap-2">
        <chitin-form-input
          data-cy="datePickerCustomStartDateInput"
          [clearable]="false"
          size="small"
          [(value)]="startDateInput"
          (valueChange)="onManualDateInputChange($event)"
          (blurred)="outputDaterange()"
        />
        <div>-</div>
        <chitin-form-input
          data-cy="datePickerCustomEndDateInput"
          [clearable]="false"
          size="small"
          [(value)]="endDateInput"
          (valueChange)="onManualDateInputChange($event)"
          (blurred)="outputDaterange()"
        />
      </div>
    }
  </div>
  <div class="flex-fill">
    <mat-calendar
      data-cy="datePickerCalendarLeft"
      #calendarLeft
      class="calendarLeft"
      startView="month"
      [startAt]="startDate()"
      [selected]="selectedDateRange()"
      (selectedChange)="selectedChange($event)"
      style="margin-top: var(--space-x-n9px)"
      [minDate]="formattedMinDate()"
      [maxDate]="formattedMaxDate()"
    />
  </div>
  <div class="flex-fill">
    <mat-calendar
      data-cy="datePickerCalendarRight"
      #calendarRight
      class="calendarRight"
      startView="month"
      [startAt]="endDate()"
      [selected]="selectedDateRange()"
      (selectedChange)="selectedChange($event)"
      style="margin-top: var(--space-x-n9px)"
      [minDate]="formattedMinDate()"
      [maxDate]="formattedMaxDate()"
    />
  </div>
</div>
@if (showTimezoneSelector()) {
  <chitin-select data-cy="datePickerTimezoneSelector" [(value)]="selectedTimezone" [options]="timezoneOptions()" />
}
